import { Component, Input } from '@angular/core';

@Component({
	selector: 'cmv-base-card',
	templateUrl: './base-card.component.html',
	styleUrls: ['./base-card.component.scss'],
})
export class BaseCardComponent {
	@Input() withShadow: boolean;
	@Input() backgroundColor: string;
	constructor() {}
}
